export const ZENJOB_CONTACT_EMAIL = 'werkstudenten@zenjob.com';
